import { MouseEvent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  SELECTOR_CONTEXT_MENU_CONTEXT_MENU_POSITION,
  SELECTOR_CONTEXT_MENU_IS_CONTEXT_MENU_VISIBLE,
  ContextMenuActionTypes,
} from 'src/store/reducers/contextMenu';
import { StatsActionTypes } from 'src/store/reducers/stats';
import { UIActionTypes } from 'src/store/reducers/ui';

const useContextMenu = () => {
  const isContextMenuVisible = useSelector(SELECTOR_CONTEXT_MENU_IS_CONTEXT_MENU_VISIBLE);
  const contextMenuPosition = useSelector(SELECTOR_CONTEXT_MENU_CONTEXT_MENU_POSITION);

  const dispatch = useDispatch();

  const showContextMenu = useCallback(
    (event: MouseEvent) => {
      event.preventDefault();
      const position = { clientX: event.clientX, clientY: event.clientY };
      dispatch({
        type: ContextMenuActionTypes.SHOW_CONTEXT_MENU,
        payload: position,
      });

      dispatch({
        type: UIActionTypes.HIDE_SETTINGS,
      });

      dispatch({
        type: StatsActionTypes.HIDE_STATS,
      });
    },
    [dispatch],
  );

  const hideContextMenu = useCallback(() => {
    dispatch({
      type: ContextMenuActionTypes.HIDE_CONTEXT_MENU,
    });
  }, [dispatch]);

  return {
    isContextMenuVisible,
    contextMenuPosition,
    showContextMenu,
    hideContextMenu,
  };
};

export default useContextMenu;
